import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

// Format string Excel per le celle numeriche.
// Il "%" è tra virgolette di proposito: i valori arrivano già moltiplicati per 100,
// e con il formato standard "0.0%" Excel rimoltiplicherebbe (31,9 → 3190%).
export const FMT_EURO = '#,##0.00 "€"';
export const FMT_PERC = '0.0"%"';

// Valore pronto per una cella Excel: numero grezzo, non stringa formattata (Excel
// tratterebbe "531K €" come testo), arrotondato a 2 decimali per togliere gli
// artefatti float, con Infinity reso esplicito (in JSON diventerebbe null).
// Da usare solo sulle colonne numeriche: su un codice come "00123" romperebbe
// gli zeri iniziali.
export const numeroPerExcel = (v) => {
    if (v == null || v === "") return "";
    if (v === Infinity || v === -Infinity) return "Infinito";
    const n = Number(v);
    if (Number.isNaN(n)) return v;
    return Math.round(n * 100) / 100;
};

// Scarica un .xlsx generato dal backend dal controller condiviso `downloadFile`
// (operazioniHrController.js). `endpoint` è il path dopo /api, es.
// "admin/bilancino/downloadExcel".
//
// `datiDaStampare` accetta due forme, entrambe già gestite dal controller:
//  - { headers, rows }               → tabella piatta, header su una riga
//  - { headerGroups, headers, rows } → header su due righe, con le celle del
//                                      primo livello unite secondo `span`
// In entrambi i casi l'ultima riga di `rows` viene messa in grassetto: passa
// sempre la riga dei totali per ultima.
//
// Campo opzionale `formattazione: { numFmt, negativiRossi, freeze }`:
// `numFmt` è un array di format string, una per colonna ("" = nessun formato).
export const scaricaExcel = async ({ endpoint, tableName, datiDaStampare, filename }) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_URL}/${endpoint}`,
        { tableName, datiDaStampare },
        { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
};
